import { Component, Input, OnInit } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { CFreeText } from '@models/imported/SagaSchema/CFreeText';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';

@Component({
  selector: 'app-callcard-detail-stamps-freetext',
  templateUrl: './callcard-detail-stamps-freetext.component.html',
  styleUrls: ['./callcard-detail-stamps-freetext.component.scss']
})
export class CallcardDetailStampsFreetext implements OnInit {
  @Input()
  callcard: CallCard;

  freeTexts: CFreeText[];

  private showFreeTextTypes: number[];

  constructor(private profileReader: ProfileReaderService) {}

  ngOnInit() {
    this.showFreeTextTypes = this.profileReader.getComponentConfig('singlecallcard', 'showFreeTextTypes', []);
    this.freeTexts = this.callcard.component<CFreeText>(CFreeText);
  }

  filterFreeTexts(freeTexts: CFreeText[]): CFreeText[] {
    return freeTexts.filter(freeText => this.showFreeTextTypes.includes(freeText.FreeTextType));
  }
}
